export default __webpack_public_path__ + "static/media/ds.50314e3b.png";